var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.329,
    height: 53.772,
    viewBox: "0 0 40.329 53.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download",
    d: "M102.649,20.165H89.494a5.335,5.335,0,0,1-5.33-5.33V1.68A3.351,3.351,0,0,1,84.613,0H67.65A3.654,3.654,0,0,0,64,3.65V50.123a3.654,3.654,0,0,0,3.65,3.65h33.03a3.654,3.654,0,0,0,3.65-3.65V19.716a3.351,3.351,0,0,1-1.68.448ZM77.936,30.739a1.679,1.679,0,0,1,2.376,0l2.173,2.172V22.685a1.68,1.68,0,1,1,3.361,0V32.911l2.173-2.172a1.68,1.68,0,1,1,2.376,2.376l-5.041,5.041a1.689,1.689,0,0,1-1.35.485c-.841-.112-.576-.035-6.067-5.526A1.679,1.679,0,0,1,77.936,30.739ZM92.566,45.37h-16.8a1.68,1.68,0,1,1,0-3.361h16.8a1.68,1.68,0,1,1,0,3.361ZM89.494,16.8h13.154L87.525,1.68V14.835A1.971,1.971,0,0,0,89.494,16.8Z",
    transform: "translate(-64)",
    fill: "#80b1b2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.82e8c721.svg";
export { ForwardRef as ReactComponent };